import InputAutocompleteList from './input_autocomplete_list';

const Realize = {
	i18n: window.Realize.i18n,
	InputAutocompleteResult: window.InputAutocompleteResult,
};

export default class InputAutocompleteResult extends Realize.InputAutocompleteResult {
	constructor(props) {
		super(props);
		this.renderSearchInput = InputAutocompleteResult.prototype.renderSearchInput.bind(this);
		this.renderList = InputAutocompleteResult.prototype.renderList.bind(this);
		this.render = InputAutocompleteResult.prototype.render.bind(this);
		this.active = 0;
	}

	componentDidMount() {
		const nodeInput = $(`#input__${this.props.id}`);
		nodeInput.mouseup(() => this.rePositionResults());
		nodeInput.mousedown(() => this.rePositionResults());

		setTimeout(() => { $('.modal-create-document').is(':visible') === true ? this.positionInputAutoCompletCreateDocument() : '' }, 1000);
	}

	rePositionResults() {
		const nodeInput = $(`#input__${this.props.id}`);
		const nodeResult = nodeInput.find(".input-autocomplete__result");
		const modalContent = nodeInput.closest(".modal-content-container");

		if (nodeResult.length) {
			const nodeInputTop = nodeInput.offset().top;
			const nodeResultHeight = nodeResult.height();
			const maxResultHeight = nodeInputTop + nodeResultHeight;
			const windowHeight = window.innerHeight;
			const boxSearch = $(`#boxSearch__${this.props.id}`);

			if (windowHeight - 100 < maxResultHeight)
				boxSearch.css('top', `-${boxSearch.height()}px`);
			else
				boxSearch.css('top', '43px');
		}

		if($('.modal-create-document').is(':visible') === true){ this.positionInputAutoCompletCreateDocument(); }
	}

	focusAutoComplete(id){
		if($('#documentModal').is(':visible') === true){
			$('#autocomplete_select_undefined').attr('tabindex', '-1');
			if(id !== undefined){
				let input = $(`#input__${id} #autocomplete_select_${id}`);
				let button = $(`#input__${id} .caret`);
				input.attr('tabindex', '-1');
				button.attr('tabindex', '-1');

				button.attr('tabindex', '0');
				button.keydown((e) => {
					if(e.which === 32 || e.which === 13)
						button[0].click();

					if(e.shiftKey){
						$(`#boxSearch__${this.props.id}`).hide();
					}
				});

				button.on('click', () => {
					if($('.fields-document-edit').is(':visible') === true){
						$('.fields-document-edit').animate({scrollTop: 300}, 500);
					}
				});

				let boxSearch = $(`#boxSearch__${id} input`);
				boxSearch.on('focus', (e) => {
					$('.modal-content-container').animate({scrollTop: 300}, 500);
					boxSearch.off('focus');
				});
			}
		}
	}

	moveActiveUp(){
		let liBoxSearch = $(`#boxSearch__${this.props.id} .input-autocomplete__list li`);
		this.active = Math.max(0, this.active -1);

		liBoxSearch.removeClass('active').eq( this.active ).addClass('active');
	}

	moveActiveDown(){
		let liBoxSearch = $(`#boxSearch__${this.props.id} .input-autocomplete__list li`);
		let lengthLi = liBoxSearch.length;

		this.active = this.active >= (lengthLi -1) ? 0 : this.active+1;

		let focusLi = liBoxSearch.removeClass('active').eq( this.active ).addClass('active');
	}

	selectOption() {
		let liBoxSearch = $(`#boxSearch__${this.props.id} .input-autocomplete__list li`);

		liBoxSearch[this.active].click();
	}

	hideResult() {
		this.active = 0;

		let boxSearch = $(`#boxSearch__${this.props.id} .input-autocomplete__clear-button`);

		boxSearch.keydown((e) => {
			// if(e.shiftKey && e.which === 9){
			// 	$(`#boxSearch__${this.props.id} input`).click();
			// }
			if(!e.shiftKey && e.which === 9){
				$(`#boxSearch__${this.props.id}`).hide();
			}
		})
	}

	renderSearchInput() {
		setTimeout(() => { this.focusAutoComplete(this.props.id)}, 1000);
		return (
			<div className="input-autocomplete__search">
				<Icon type="search" className="prefix" />
				<InputText
					// onKeyDown={this.props.onKeyDown}
					onKeyDown={(event) => {
						// console.log(this.props.onKeyDown)
						var keyCode = event.keyCode;

						if(keyCode === 38){ this.moveActiveUp(); }
						else if(keyCode === 40){ this.moveActiveDown();	}
						else if (keyCode === 27 || keyCode === 9) { this.hideResult(); }
						else if (keyCode === 13) {
							event.preventDefault();
							this.selectOption();
						}
					}}
					value={this.props.searchValue}
					onChange={this.props.onChange}
					autoComplete="off"
					ref="inputSearch"
				/>
			</div>
		);
	}

	renderList() {
		const Component = this.props.autocompleteListComponent || InputAutocompleteList;

		return (
			<Component
				id={this.props.id}
				selectedOptions={this.props.selectedOptions}
				options={this.props.options}
				active={this.props.active}
				onSelect={this.props.onSelect}
				onOptionMouseEnter={this.props.onOptionMouseEnter}
				ref="list"
			/>
		);
	}

	positionInputAutoCompletCreateDocument(){
		if($('#documentModal').is(':visible') === true){
			let button = $(`#documentModal #input__undefined .caret`);
			button.on('click', () => {
				let heightModal = $('#documentModal .modal-content-container').height();
				let heightAutocomplete = $('#documentModal .modal-create-document .input-autocomplete #boxSearch__undefined').height();

				if(heightAutocomplete > heightModal){
					$('#documentModal .modal-content-container').css('height', heightModal + heightAutocomplete);
				}
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		this.rePositionResults();
	}

	renderClearButtonCustom () {
		return (
			<div style={{borderBottom: '1px solid rgba(0, 0, 0, 0.2)'}}>
				<button style={{background: 'transparent', border: 'none', color: '#039be5'}}
					className="input-autocomplete__clear-button"
					onClick={this.props.onClear}>
			
					{Realize.i18n.t("inputs.autocomplete.clear")} 
				</button>
		  	</div>
		);
	  }

	render() {
		return (
			<div id={`boxSearch__${this.props.id}`} className={this.className()}>
				{this.renderSearchInput()}
				{this.renderClearButtonCustom()}
				{this.renderResult()}
				{this.renderActionButtons()}
		  	</div>
		);
	}
}
